









































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SystemLeftNav extends Vue {
  @Prop()
  private cState: any;
}
